import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DxCheckBoxModule, DxTagBoxModule } from 'devextreme-angular';
import { ReportEntityFilterComponent } from './report-entity-filter.component';

@NgModule({
  declarations: [ReportEntityFilterComponent],
  imports: [CommonModule, DxCheckBoxModule, DxTagBoxModule],
  exports: [ReportEntityFilterComponent],
})
export class ReportEntityFilterModule {}
